import { render, staticRenderFns } from "./PageTitleSection.vue?vue&type=template&id=1e115905&scoped=true"
import script from "./PageTitleSection.vue?vue&type=script&lang=ts"
export * from "./PageTitleSection.vue?vue&type=script&lang=ts"
import style0 from "./PageTitleSection.vue?vue&type=style&index=0&id=1e115905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e115905",
  null
  
)

export default component.exports